import FeatureGates from '@atlaskit/feature-gate-js-client';

// experiment has been completed but just leaving the name as is to minimize other file changes
// will delete as part of https://product-fabric.atlassian.net/browse/PGXT-4920
export const getPagePropertiesReportExperimentEnabled = () => {
	return FeatureGates.checkGate('confluence_ppr_adf_rendering');
};
